export const computeChangeRate = (currentYear: number, previousYear: number) => {
  let changeRate = previousYear === 0 ? 1 : (currentYear - previousYear) / previousYear;
  if (!previousYear && !currentYear) {
    changeRate = 0;
  }
  return changeRate;
};
